import { LayoutDashboard } from "lucide-react";
import { AppLogo } from "@/shared/ui/AppLogo";
import { cn } from "@/shared/lib/utils";

type Props = {
  size?: "lg" | "xl";
  className?: string;
};

/** Full wordmark + back-office badge overlapping the card bottom edge */
export function AdminBrandLogo({ size = "lg", className }: Props) {
  return (
    <div className={cn("relative inline-flex pb-5", className)}>
      <AppLogo variant="full" size={size} framed />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2">
        <div className="bg-mineral-navy text-mineral-off-white inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 shadow-md ring-2 ring-background">
          <LayoutDashboard className="text-mineral-gold size-3.5 shrink-0" />
          <span className="text-[11px] font-semibold tracking-wide whitespace-nowrap">
            Back Office
          </span>
        </div>
      </div>
    </div>
  );
}
